<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <!-- Start:: Loading State -->
        <div v-if="loading" class="loading_wrapper">
          <div class="spinner"></div>
          <p class="loading_text">{{ $t("TABLES.loadingData") || "جاري التحميل..." }}</p>
        </div>
        <!-- End:: Loading State -->

        <!-- Start:: Notifications List -->
        <transition-group name="fade" v-else-if="receivedMessages.length">
          <div
            class="notification"
            :class="{ read: message.is_read == true }"
            v-for="(message, index) in receivedMessages"
            :key="'k' + index"
            @click="handleNotificationClick(message)"
            style="cursor: pointer;"
          >
            <div
              v-if="true"
              @click="handleNotificationClick(message)"
            >
              <h3>{{ message.title }}</h3>
              <p>{{ message.body }}</p>
            </div>
            <div
              class="delete_notification"
              :class="{ read: message.is_read }"
              v-if="!message.is_read"
            >
              <i class="fas fa-check-double"></i>
            </div>
            <div
              class="delete_notification"
              :class="{ read: message.is_read }"
              style="cursor: default;"
              v-if="message.is_read"
            >
              <i class="fas fa-check-double"></i>
            </div>
          </div>
        </transition-group>
        <!-- End:: Notifications List -->

        <!-- Start:: Empty State -->
        <p class="text-danger text-center text--darken-4 pt-5 pb-5" v-else>
          {{ $t("PLACEHOLDERS.no_notifications") }}
        </p>
        <!-- End:: Empty State -->

        <!-- Start:: Pagination -->
        <template v-if="!loading && receivedMessages.length">
          <div class="pagination_container text-center mt-3 mb-0">
            <v-pagination
              class="py-0"
              square
              v-model="paginations.current_page"
              :length="paginations.last_page"
              :total-visible="6"
              @input="updateRouterQueryParam($event)"
              :prev-icon="
                getAppLocale == 'ar'
                  ? 'fal fa-angle-right'
                  : 'fal fa-angle-left'
              "
              :next-icon="
                getAppLocale == 'ar'
                  ? 'fal fa-angle-left'
                  : 'fal fa-angle-right'
              "
            />
          </div>
        </template>
        <!-- End:: Pagination -->
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "CreateContact",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      loading: false,
      // End:: Loader Control Data

      receivedMessages: [],

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 6,
      },
      // End:: Pagination Data
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
      notificationsData: "NotificationsModule/notificationsData",
    }),
  },

  watch: {
    // Start:: Page Query Param Watcher To Get Page Data Based On It's Change
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.getData();
    },
    // End:: Page Query Param Watcher To Get Page Data Based On It's Change
  },

  methods: {
    ...mapActions({
      readAllNotifications: "NotificationsModule/readAllNotifications",
    }),
    // تحديد مسار كل إشعار حسب نوعه
    getNotificationRoute(message) {
      const type = message?.data?.type;
      const id = message?.data?.id;

      if (!type) return null;

      switch (type) {
        // رسائل "تواصل معنا"
        case "contact_us":
          return id ? `/contact-messages/show/${id}` : "/contact-messages/all";

        // تسجيل عميل جديد
        case "new_client":
          return id ? `/clients/show/${id}` : "/clients/all";

        // تسجيل مطبعة جديدة (مقدم خدمة)
        case "new_printShop":
          return id ? `/providers/show/${id}` : "/providers/all";

        // إضافة مندوب جديد
        case "new_representative":
          return id ? `/representatives/show/${id}` : "/representatives/all";

        // الطلبات (جديد / تغيير حالة / إلغاء / إسناد لمندوب)
        case "order":
        case "new_order":
        case "order_status":
        case "order_cancelled":
        case "order_assigned_to_representative":
          return id ? `/orders/show/${id}` : "/orders/all";

        // طلبات تصفية المحفظة (للوحة التحكم)
        case "wallet":
        case "wallet_clearance_request":
        case "wallet_top_up":
        case "wallet_clearance_accepted":
        case "wallet_clearance_rejected":
        case "wallet_balance_adjusted":
          return "/request-wallets/all";

        // التقييمات
        case "rating":
        case "rating_moderation":
        case "new_review":
          return "/reviews/all";

        // حذف الحسابات
        case "delete_account":
          return "/clients/all";
        case "delete_representative":
          return "/representatives/all";
        case "delete_print_shop":
          return "/providers/all";

        // إشعارات أخرى لا تتطلب توجيهاً محدداً
        case "admin_notification":
        default:
          return null;
      }
    },
    async getData() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: "notification/admin-notifications",
          params: {
            page: this.paginations.current_page,
          },
        });
        this.receivedMessages = res.data.data.data;
        this.paginations.last_page = res.data.data.meta.last_page;
        this.paginations.items_per_page = res.data.data.meta.per_page;
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
        this.$message.error(error.response?.data?.message || 'حدث خطأ أثناء جلب الإشعارات');
      } finally {
        this.loading = false;
      }
    },

    // async DeleteNotification(item_id) {
    //   const REQUEST_DATA = new FormData();
    //   REQUEST_DATA.append("_method", "PUT");
    //   try {
    //     let res = await this.$axios({
    //       method: "POST",
    //       url: `notifications/${item_id}`,
    //       params: REQUEST_DATA,
    //     });
    //     this.$message.success(res.data.message);
    //     this.getData();
    //   } catch (error) {
    //     this.dialogDelete = false;
    //     this.$message.error(error.response.data.errors);
    //   }
    // },

    async NotificationsReaded(item_id, updateImmediately = true) {
      // Find the message first
      const message = this.receivedMessages.find((msg) => msg.id === item_id);
      
      // Update immediately (optimistic update)
      if (updateImmediately && message && !message.is_read) {
        message.is_read = true;
        if (this.notificationsData.unreadNotifications > 0) {
          this.notificationsData.unreadNotifications--;
        }
      }

      try {
        const REQUEST_DATA = new FormData();
        REQUEST_DATA.append("notification_id", item_id);

        let res = await this.$axios({
          method: "POST",
          url: `notification/mark-as-read`,
          data: REQUEST_DATA,
        });

        // Refresh notifications count
        this.readAllNotifications();
      } catch (error) {
        // Revert the optimistic update on error
        if (updateImmediately && message) {
          message.is_read = false;
          if (this.notificationsData.unreadNotifications >= 0) {
            this.notificationsData.unreadNotifications++;
          }
        }
        this.$message.error(error.response?.data?.message || error.response?.data?.errors || 'حدث خطأ');
      }
    },
    async handleNotificationClick(message) {
      // 1. Get the target route
      const route = this.getNotificationRoute(message);

      // 2. Mark as read if not already read
      if (!message.is_read) {
         // Pass false for 'updateImmediately' to wait for navigation or handle it differently if needed,
         // but here we just want to ensure the API call happens.
         // We await it so we don't navigate before we know it's triggered (optional).
         await this.NotificationsReaded(message.id, true);
      }

      // 3. Navigate if a route exists
      if (route) {
        this.$router.push(route).catch(() => {});
      }
    },
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      // Scroll To Screen's Top After Get Products
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
  },

  created() {
    this.getData();

    navigator.serviceWorker.addEventListener("message", (event) => {
      const receivedMessage = event.data.data;

      this.receivedMessages.unshift(receivedMessage);
      this.getData();
      this.readAllNotifications();
      this.notificationsData.unreadNotifications--;

      console.log(event.data.data);
      // console.log("receivedMessage", event)
      // Update component state or display the received message in the UI
    });

    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
.show_order {
  cursor: pointer;
  i {
    font-size: 20px;
    position: absolute;
    top: 20px;
    left: 60px;
  }
}
.notification {
  background: #000;
  padding: 30px;
  border-radius: 8px;
  text-align: center;
  margin-bottom: 20px;
  position: relative;

  .delete_notification {
    position: absolute;
    z-index: 500 !important;
    top: 20px;
    left: 20px;
    cursor: pointer;

    &.read {
      i {
        color: #49a956;
      }
    }

    i {
      font-size: 20px;
      color: #ddd;
    }
  }
}

.text-danger {
  font-size: 22px;
}

.loading_wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  min-height: 300px;

  .spinner {
    width: 50px;
    height: 50px;
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-top-color: var(--main_theme_clr, #3eb6d4);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
  }

  .loading_text {
    font-size: 16px;
    color: var(--theme_text_clr, #333);
    margin-top: 10px;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
